import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import minMax from 'dayjs/plugin/minMax';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';
import { RawIntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';
import { App } from 'src/app';
import { initEnvConfig } from 'src/helpers/init';
import { updateIntl } from 'src/services/intl/intl';
import { queryClient } from 'src/services/react-query/query-client';
import { initScripts } from 'src/services/script/script';
import { THEME_COMPONENTS, THEME_TOKEN } from 'src/theme/theme';

dayjs.extend(utc);
dayjs.extend(minMax);
dayjs.extend(customParseFormat);

const initApp = async () => {
  const rootElement = document.getElementById('root');

  if (!rootElement) throw new Error('Failed to find the root element');

  await initEnvConfig();
  initScripts();

  createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <RawIntlProvider value={updateIntl()}>
        <ConfigProvider
          theme={{
            token: THEME_TOKEN,
            components: THEME_COMPONENTS,
          }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </RawIntlProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
  );
};

initApp();
